import React from 'react';
import { useTranslation } from 'react-i18next';
import HardwareSignupCard from '../../../HardwareSignupCard/HardwareSignupCard';
import { DEVICE_USAGE_TYPE, TYPE_OF_PRINTING } from '../../../../../../constants/AppConstants';

const DisplayTypeOfPrinting = (props) => {
    const { handleSelectionChange, selectedData } = props
    const { t } = useTranslation(["translation"])

    return (
        <div className='cp-printer-feature-wrapper'>
            <div className='cp-subtitle'>{t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.PRINT_OUTPUT.HEADER")}</div>
            <div className='cp-card'>
                <HardwareSignupCard
                    onHardwarePlanSelection={handleSelectionChange}
                    selectedCard={selectedData?.typeOfPrinting}
                    toCompareSelectedCardWith= {TYPE_OF_PRINTING.MONO}
                    cardRightData={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.PRINT_OUTPUT.MONO")}
                ></HardwareSignupCard>
                {selectedData?.deviceType === DEVICE_USAGE_TYPE.NEW_PRINTER_BUNDLE &&
                    <HardwareSignupCard
                        onHardwarePlanSelection={handleSelectionChange}
                        selectedCard={selectedData?.typeOfPrinting}
                        toCompareSelectedCardWith={TYPE_OF_PRINTING.COLOUR}
                        cardRightData={t("HARDWARE_SIGNUP.CUSTOMIZE_PRINTER.PRINT_OUTPUT.COLOUR")}
                    ></HardwareSignupCard>}
            </div>
        </div>
    );
};

export default DisplayTypeOfPrinting;